import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';      // changed from components
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';  // changed from components
import TermsPage from './pages/TermsPage';      // changed from components
import DownloadPage from './pages/DownloadPage';  // new import
import BusinessPage from './pages/BusinessPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
         <Route path="download" element={<DownloadPage />} />  // new route
                   <Route path="/business" element={<BusinessPage />} />
         
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;